import { useFeatureFlagEnabled } from "posthog-js/react";

import { POSTHOG_FEATURE_FLAGS } from "context/posthog/featureFlags";

/**
 * Kill switch for the SCA setup (passkey creation) flow.
 *
 * Used to block new passkeys during the migration from Hanko cloud
 * to the self-hosted instance. Remove once the migration is done.
 */
export function useDisableSCASetupFeatureFlag() {
  return Boolean(useFeatureFlagEnabled(POSTHOG_FEATURE_FLAGS.disableSCASetup));
}
